import { get } from "services/actions";
import AppError from "errors/AppError";
import strapiImg from "utils/strapiImg";
import DetalhesImovelPage from "components/pages/DetalhesImovel";
import AppLayout from "components/AppLayout";

export default function Detalhes({ propriety, appLayout }) {
  return (
    <>
      <AppLayout data={appLayout}>
        <DetalhesImovelPage data={propriety} />
      </AppLayout>
    </>
  );
}

export async function getStaticPaths() {
  const featuredProperties = await get("imoveis", {
    destaque_home: true,
  });

  const paths = featuredProperties.map((propriety) => {
    return {
      params: {
        slug: propriety.slug,
      },
    };
  });

  return {
    paths,
    fallback: "blocking",
  };
}

export async function getStaticProps(ctx) {
  const { slug } = ctx.params;

  const data = await get("imoveis", { slug });
  const andamento = await get("andamento-obras", { "imovel.slug": slug });

  if (data.length === 0) {
    throw new AppError(404);
  }

  const outros = await get("imoveis", {
    "cidades.cidade": data[0]?.cidades.cidade,
    _limit: 3,
    _sort: "id:DESC",
  });

  const header = await get("cabecalho");
  const footer = await get("rodape");
  const receiveNews = await get("receba-novidades");

  const appLayout = {
    header: {
      logo: header?.logo ? strapiImg(header.logo, "", true) : "",
      menu: header?.menu ? header.menu : "",
    },
    footer: {
      logo: footer?.logo ? strapiImg(footer.logo, "", true) : "",
      redes: footer?.redes_sociais
        ? footer.redes_sociais.map(({ id, nome, link, icone }) => {
            icone = strapiImg(icone, "", true);
            return {
              id,
              nome,
              link,
              icone,
            };
          })
        : "",
      unidades: footer?.unidades ? footer.unidades : "",
      submenus: footer?.unidades ? footer.submenu : "",
      whatsappIcon: strapiImg(footer?.icone_whatsapp_rodape, "", true),
      openChatBot: footer?.habilitar_chatbot
    },
  };

  const propriety = {
    seo: {
      titulo: data[0]?.SEO
        ? data[0].SEO.title
          ? data[0].SEO.title
          : data[0].nome
        : data[0]?.nome
        ? data[0].nome
        : "",
      descricao: data[0]?.SEO
        ? data[0].SEO.description
          ? data[0].SEO.description
          : data[0].chamada_banner
        : data[0]?.chamada_banner
        ? data[0].chamada_banner
        : "",
      imagem: data[0]?.SEO
        ? strapiImg(data[0]?.banner_imovel, "", true)
        : strapiImg(data[0]?.banner_imovel, "medium", true),
    },
    banner: {
      imagem: data[0]?.banner_imovel
        ? strapiImg(data[0].banner_imovel, "", true)
        : "",
      nome: data[0]?.nome ? data[0].nome : "",
      chamada: data[0]?.chamada_banner ? data[0].chamada_banner : "",
      cidade: {
        cidade: data[0]?.cidades.cidade ? data[0].cidades.cidade : "",
        uf: data[0]?.cidades.uf ? data[0].cidades.uf : "",
      },
      etapaImovel: {
        etapa: data[0]?.etapas_imovel ? data[0].etapas_imovel.etapa : "",
        cor: data[0]?.etapas_imovel ? data[0].etapas_imovel.cor : "",
      },
    },
    detalhes: {
      iconeImovel: strapiImg(data[0]?.icone_imovel, "", true),
      unidade: {
        nome: data[0]?.unidades ? data[0].unidades.nome : "",
        texto: data[0]?.unidades ? data[0].unidades.texto : "",
      },
      detalhesItems: data[0]?.detalhes_imovel
        ? data[0].detalhes_imovel.map((item) => {
            return {
              id: item.id,
              icone: strapiImg(item.icone, "", true),
              detalhe: item.detalhe,
            };
          })
        : "",
    },
    descricaoImovel: {
      titulo: data[0]?.secao_descricao_imovel
        ? data[0]?.secao_descricao_imovel?.titulo
        : "",
      descricao: data[0]?.secao_descricao_imovel
        ? data[0]?.secao_descricao_imovel?.descricao
        : "",
    },
    localizacao: {
      titulo: data[0]?.secao_localizacao
        ? data[0]?.secao_localizacao?.titulo
        : "",
      descricao: data[0]?.secao_localizacao
        ? data[0]?.secao_localizacao?.descricao
        : "",
      mapa: data[0]?.secao_localizacao
        ? strapiImg(data[0]?.secao_localizacao?.mapa_imagem, "", true)
        : "",
      link: data[0]?.secao_localizacao
        ? data[0]?.secao_localizacao?.botao_rotas_link
        : "",
      unidade: {
        nome: data[0]?.unidades ? data[0].unidades.nome : "",
        texto: data[0]?.unidades ? data[0].unidades.texto : "",
      },
    },
    galeria: data[0]?.galeria
      ? data[0].galeria.map((item) => {
          return {
            id: item.id,
            ambiente: item.ambientes_galeria_fotos
              ? item.ambientes_galeria_fotos.nome
              : "",
            imagens: item.imagem
              ? item.imagem.map((img) => {
                  return {
                    id: img.id,
                    legenda: img.caption,
                    img: strapiImg(img, "", true),
                  };
                })
              : "",
          };
        })
      : "",
    secaoRecebaNovidades: {
      imagem: receiveNews?.background_imagem
        ? strapiImg(receiveNews.background_imagem, "", true)
        : "",
      email: receiveNews?.email_de_envio ? receiveNews.email_de_envio : "",
    },
    andamento_obras: {
      modulos: andamento[0]?.modulo_item
        ? andamento[0]?.modulo_item.map((item) => {
            return {
              id: item.id,
              nome: item.modulo_nome,
              etapas: item.etapas.map((etapa) => {
                return {
                  id: etapa.id,
                  nome: etapa.nome_etapa,
                  porcentagem: etapa.porcentagem,
                };
              }),
              galeria: item?.galeria.map((itemImg) => {
                return {
                  id: itemImg.id,
                  img: strapiImg(itemImg, "", true),
                };
              }),
            };
          })
        : null,
    },
    outros:
      outros && outros.length > 0
        ? outros.map((item) => {
            return {
              id: item.id,
              nome: item.nome,
              cidades: item.cidades,
              etapasImovel: item.etapas_imovel,
              tipologia: item.tipologia,
              descricao: item.descricao,
              slug: item.slug,
              imagemCard: strapiImg(item.imovel_imagem, "", true),
            };
          })
        : null,
  };

  return {
    props: {
      propriety,
      appLayout,
    },
    revalidate: 60,
  };
}
